/**
 * Alert duration constants
 *
 * Centralized alert display durations to avoid magic numbers.
 */

export const ALERT_DURATIONS = {
  /** Default alert duration (4 seconds) */
  DEFAULT: 4000,

  /** Extended duration for alerts with links (7 seconds) */
  WITH_LINK: 7000,

  /** Standard duration for most app alerts (4 seconds) */
  STANDARD: 4000,
} as const;
